import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20flowing%20neon%20light%20waves%20in%20red%20and%20warm%20gold%20colors%20dark%20background%20modern%20tech%20cinematic%20atmosphere%20smooth%20gradient%20curves%20elegant%20minimal%20design&width=1600&height=600&seq=mahua-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-900/90 via-background-900/70 to-background-900/90"></div>

      <div className="relative z-10 container-page text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好了吗？立即开始免费观影
        </h2>
        <p className="text-base text-white/65 mb-8 max-w-lg mx-auto">
          海量高清影视资源，无需注册，无需会员，随时随地畅享精彩内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-white/20 text-white font-semibold text-base hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}